import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import HeroVideo from "../components/hero-video"
import Video from "../components/video"
import SliderGallery from "../components/slider-gallery"
import Aziende from "../components/aziende"
// import Sponsor from "../components/sponsor"
import RassegnaStampa from "../components/rassegna-stampa"
// import Newsletter from "../components/newsletter"
import Programma from "../components/programma"
import Tickets from "../components/tickets"
// import BannerIIC from "../components/banner-iic"
import TextHpIID from "../components/text-hp-iid"
import Banner from "../components/banner"
// import IIDModal from "../components/iid-modal"
// import BannerOnline from "../components/banner-online"
// import TicketsLiveOnline from "../components/tickets-live-online"


const IndexPage = ({ pageContext: { locale } }) => {
  return (
    <Layout locale={locale}>
      <SEO bodyClass="header-testata" />
      <HeroVideo />
      <div className="bg-fagioloni">
        <div className="bg-fagioloni__left"></div>
        <div className="bg-fagioloni__right"></div>
        {/* <BannerOnline /> */}
        {/* <BannerIIC /> */}
        <TextHpIID />
        <Video />
        <SliderGallery />
        <Programma />
        {/* <TicketsLiveOnline id="tickets-online" /> */}
        <Tickets />
        <Banner />
        <Aziende />
        <RassegnaStampa featured={true} />
        {/* <Newsletter /> */}
      </div>
      {/* <IIDModal />*/}
    </Layout>
  )
};

export default IndexPage;
